import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useLang } from "../i18n/LangContext";
import { SEOHead } from "../components/SEOHead";

export function ImpressumPage() {
  const { t } = useLang();

  return (
    <>
      <SEOHead
        title={t("impressumTitle")}
        description={t("impressumDisclaimerBody").slice(0, 160)}
        path="/impressum"
        noindex
      />
      <main className="page page--text">
        <article className="text-article">
          <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 3 }}>
            {t("impressumTitle")}
          </Typography>

          <section className="text-section">
            <h2>{t("impressumLegalSection")}</h2>
            <p>
              Moritz Habegger
              <br />
              Zürich, Schweiz
            </p>
          </section>

          <section className="text-section">
            <h2>{t("impressumContactSection")}</h2>
            <p>
              <Link href="mailto:hi@fishing-iceland.app">hi@fishing-iceland.app</Link>
            </p>
          </section>

          <section className="text-section">
            <h2>{t("impressumDataSection")}</h2>
            <p>{t("impressumDataBody")}</p>
          </section>

          <section className="text-section">
            <h2>{t("impressumDisclaimerSection")}</h2>
            <p>{t("impressumDisclaimerBody")}</p>
          </section>
        </article>
      </main>
    </>
  );
}
